import React, { useState, useEffect } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { Typography, Spin, Menu, Col } from 'antd';
import { getCourseEnrolments } from '../../services/courseEnrolmentService';
import CourseEnrolmentTable from '../courseEnrolment/CourseEnrolmentTable';
import CourseEnrolmentModal from '../courseEnrolment/CourseEnrolmentModal';
import CourseEnrolmentBulkEdit from '../courseEnrolment/CourseEnrolmentBulkEdit';
import ActionHeader from '../Common/ActionHeader';
import { createCourseEnrolment } from '../../services/courseEnrolmentService';
import {
  formatCourseEnrolmentCSVData,
  getEnrolmentCountMap,
} from '../../utilities/courseEnrolment';
import { CSVLink } from 'react-csv';
import { validEnrolmentStatuses } from './constants';

const { Text, Title } = Typography;

const CourseEnrolmentSection = (props) => {
  const { id } = useParams();
  const { courseOffer } = props;
  const [courseEnrolments, setCourseEnrolments] = useState([]);
  const [totalCourseEnrolments, setTotalCourseEnrolments] = useState(0);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isBulkEditModalVisible, setIsBulkEditModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [status, setStatus] = useState({
    error: false,
    message: '',
  });
  const [addEnrolmentFormData, setAddEnrolmentFormData] = useState({
    courseOfferCode: courseOffer.code,
    courseOfferId: courseOffer.courseOfferId,
    learnerId: '',
    firstName: '',
    lastName: '',
    courseEnrolmentStatus: '',
  });
  const [csvData, setCSVData] = useState({});
  const [enrolmentStatusCountMap, setEnrolmentStatusCountMap] = useState({});

  const actionMenu = (
    <Menu>
      <Menu.Item onClick={() => setIsAddModalVisible(true)}>
        Add Course Enrolment
      </Menu.Item>
      <Menu.Item onClick={() => setIsBulkEditModalVisible(true)}>
        Bulk Edit Selected
      </Menu.Item>
      {csvData.data && csvData.data.length > 0 ? (
        <Menu.Item>
          <CSVLink
            data={csvData.data}
            headers={csvData.headers}
            filename={csvData.filename}
          >
            Export enrolment CSV
          </CSVLink>
        </Menu.Item>
      ) : null}
    </Menu>
  );

  const addCourseEnrolmentHandler = () => {
    const body = addEnrolmentFormData;
    createCourseEnrolment(body)
      .then(() => {
        setIsAddModalVisible(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`,
        });
      });
  };

  useEffect(() => {
    setIsLoading(true);
    getCourseEnrolments(0, 0, {
      courseOfferId: id,
    })
      .then((response) => {
        setTotalCourseEnrolments(response.data.totalCount);
        const courseEnrolments = response.data.paginatedList;
        setCourseEnrolments(courseEnrolments);
        setEnrolmentStatusCountMap(getEnrolmentCountMap(courseEnrolments));
        const activeCourseEnrolments = courseEnrolments.filter((record) =>
          validEnrolmentStatuses.includes(record.courseEnrolmentStatus)
        );
        setCSVData(formatCourseEnrolmentCSVData(activeCourseEnrolments));
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`,
        });
      });
    setIsLoading(false);
  }, [id]);

  return (
    <>
      <div
        style={{
          paddingBottom: '10px',
        }}
      >
        <Text
          style={{
            float: 'left',
            position: 'relative',
          }}
        >
          Total Course Enrolment:{' '}
          <strong style={{ fontSize: '20px' }}>{totalCourseEnrolments}</strong>{' '}
          records
          {Object.keys(enrolmentStatusCountMap).length > 0 ? (
            <span>
              <span> ({enrolmentStatusCountMap.currentCount} current - </span>
              <span>{enrolmentStatusCountMap.pendingCount} pending - </span>
              <span>{enrolmentStatusCountMap.completedCount} completed - </span>
              <span>
                {enrolmentStatusCountMap.transferredCount} transferred -{' '}
              </span>
              <span>
                {enrolmentStatusCountMap.canceledCount}{' '}
                withdrawn/canceled/inactive)
              </span>
            </span>
          ) : null}
        </Text>
        <ActionHeader actionMenu={actionMenu} />
      </div>
      <CourseEnrolmentModal
        isVisible={isAddModalVisible}
        setIsVisible={setIsAddModalVisible}
        handleOk={addCourseEnrolmentHandler}
        formData={addEnrolmentFormData}
        updateFormData={setAddEnrolmentFormData}
        title={'Add new Course Enrolment '}
      />
      <CourseEnrolmentBulkEdit
        isVisible={isBulkEditModalVisible}
        setIsVisible={setIsBulkEditModalVisible}
        selectedRowKeys={selectedRowKeys}
        formData={{
          courseOfferCode: courseOffer.code,
          courseOfferId: courseOffer.courseOfferId,
          learners: selectedRows,
          courseEnrolmentStatus: '',
        }}
      />

      {isLoading ? (
        <div
          style={{
            textAlign: 'center',
            marginTop: '50px',
          }}
        >
          <Spin />
        </div>
      ) : status.error ? (
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <Title>{status.message}</Title>
        </div>
      ) : (
        <CourseEnrolmentTable
          data={courseEnrolments}
          setSelectedRowKeys={setSelectedRowKeys}
          setSelectedRows={setSelectedRows}
        />
      )}
    </>
  );
};

export default withRouter(CourseEnrolmentSection);
